import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#custom-color" }),
  /*#__PURE__*/_createTextVNode(" Custom color ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" You can use "),
  /*#__PURE__*/_createVNode("code", null, "color"),
  /*#__PURE__*/_createTextVNode(" attr to set the progress bar color. it accepts color string, function, or array. ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_progress = _resolveComponent("el-progress")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_button_group = _resolveComponent("el-button-group")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_progress, {
        percentage: _ctx.percentage,
        color: _ctx.customColor,
        class: "mb-5"
      }, null, 8, ["percentage", "color"]),
      _createVNode(_component_el_progress, {
        percentage: _ctx.percentage,
        color: _ctx.customColorMethod,
        class: "mb-5"
      }, null, 8, ["percentage", "color"]),
      _createVNode(_component_el_progress, {
        percentage: _ctx.percentage,
        color: _ctx.customColors,
        class: "mb-5"
      }, null, 8, ["percentage", "color"]),
      _createVNode("div", null, [
        _createVNode(_component_el_button_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: "el-icon-minus",
              onClick: _ctx.decrease
            }, null, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              icon: "el-icon-plus",
              onClick: _ctx.increase
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code3), 1)
        ]),
        _: 1
      })
    ])
  ]))
}